(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    (() => {
  const main = document;
  let queued = false;
  let observedBuy;
  let visibility;
  const setText = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  function update() {
    const root = main.querySelector('.sb-product');
    if (!root) return;
    root.querySelectorAll('.mw-option').forEach(option => {if(/stone/i.test(option.querySelector('.mw-text--style-strong')?.textContent || '')) option.classList.add('sb-stone-choice');});
    const guide = root.querySelector('.sb-guide');
    const option = guide?.closest('.mw-option');
    const heading = option?.firstElementChild?.firstElementChild;
    if (guide && heading && heading.nextElementSibling !== guide) heading.after(guide);
    const summary = root.querySelector('[data-sb-summary]');
    const sticky = root.querySelector('[data-sb-sticky]');
    const buy = root.querySelector('button.mw-apo-add-to-cart-cloned') || root.querySelector('button.add-to-cart-btn');
    const price = root.querySelector('.mw-apo-price-custom .mw-text--style-strong') || root.querySelector('[data-product-price]');
    if (price) {
      const value = price.textContent.trim();
      setText(summary?.querySelector('[data-sb-piece]'), value);
      if (summary) {
        const locale = document.documentElement.lang || 'en-GB';
        const parts = new Intl.NumberFormat(locale).formatToParts(1234.5);
        const group = parts.find(p => p.type === 'group')?.value;
        const decimal = parts.find(p => p.type === 'decimal')?.value || '.';
        let numeric = value.replace(/[^0-9.,\s\u00a0\u202f]/g, '');
        if (group) numeric = numeric.split(group).join('');
        numeric = numeric.replace(decimal, '.').replace(/\s/g, '');
        const amount = Number(numeric);
        const kit = Number(summary.dataset.kitPrice) / 100;
        const total = summary.querySelector('[data-sb-total]');
        if (numeric && Number.isFinite(amount) && Number.isFinite(kit)) {
          setText(total, new Intl.NumberFormat(locale, {style:'currency',currency:summary.dataset.currency || 'GBP'}).format(amount + kit));
        }
      }
      setText(sticky?.querySelector('[data-sb-sticky-price]'), value);
    }
    const form = root.querySelector('form[action*="/cart/add"]');
    if (summary && buy && form && summary.nextElementSibling !== buy) buy.before(summary);
    if (sticky && buy && buy !== observedBuy) {
      visibility?.disconnect();
      observedBuy = buy;
      visibility = new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting;}, {threshold:0});
      visibility.observe(buy);
    }
  }
  main.addEventListener('click', event => {
    if (!event.target.closest('[data-sb-review]')) return;
    const root = main.querySelector('.sb-product');
    const incomplete = root.querySelector('.sb-teeth[data-valid="false"]');
    const buy = root.querySelector('button.mw-apo-add-to-cart-cloned') || root.querySelector('button.add-to-cart-btn');
    const target = incomplete || root.querySelector('[data-sb-summary]') || buy;
    target?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
    (incomplete?.querySelector('button:not(:disabled)') || buy)?.focus({preventScroll:true});
  });
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {queued = false; update();});
  }).observe(document.documentElement,{subtree:true,childList:true});
  main.addEventListener('change', update);
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
